export const REQUEST_MASTER_USERS = "REQUEST_MASTER_USERS";
export const SET_MASTER_USERS = "SET_MASTER_USERS";
export const ERROR_GET_MASTER_USERS = "ERROR_GET_MASTER_USERS";

export const REQUEST_CREATE_MASTER_USERS = "REQUEST_CREATE_MASTER_USERS";
export const SUCCESS_CREATE_MASTER_USERS = "SUCCESS_CREATE_MASTER_USERS";
export const ERROR_CREATE_MASTER_USERS = "ERROR_CREATE_MASTER_USERS";

export const REQUEST_UPDATE_MASTER_USERS = "REQUEST_UPDATE_MASTER_USERS";
export const SUCCESS_UPDATE_MASTER_USERS = "SUCCESS_UPDATE_MASTER_USERS";
export const ERROR_UPDATE_MASTER_USERS = "ERROR_UPDATE_MASTER_USERS";

export const REQUEST_DELETE_MASTER_USERS = "REQUEST_DELETE_MASTER_USERS";
export const SUCCESS_DELETE_MASTER_USERS = "SUCCESS_DELETE_MASTER_USERS";
export const ERROR_DELETE_MASTER_USERS = "ERROR_DELETE_MASTER_USERS";

export const SET_MESSAGE_MASTER_USERS = "SET_MESSAGE_MASTER_USERS";